export default __webpack_public_path__ + "static/media/landing-background.1b3adfff.jpg";